import React, { useState, useEffect } from 'react';
import { api } from '../../App';
import toast from 'react-hot-toast';

const QUICK = [
  'Who are the top 5 candidates for a closer role?',
  'Which applicants have real solar experience and a vehicle?',
  'Prioritize bilingual candidates with a 20%+ closing rate',
  'Who should I interview this week?',
];

export default function RecruitingAssistant() {
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { api.get('/api/hiring/jobs').then(r => setJobs(r.data.jobs || [])).catch(() => {}); }, []);

  const ask = async (msg) => {
    const q = msg || message;
    if (!q.trim()) return;
    setLoading(true); setResult(null);
    try {
      const r = await api.post('/api/hiring/assistant', { message: q, job_id: jobId || undefined });
      setResult(r.data);
    } catch { toast.error('Assistant unavailable'); }
    setLoading(false);
  };

  return (
    <div className="space-y-5" data-testid="assistant-panel">
      <div className="bg-gradient-to-br from-primary/10 to-emerald-500/5 rounded-2xl border border-border p-6">
        <p className="text-sm font-bold text-text-primary"><i className="fa-solid fa-robot text-primary mr-2" />AI Recruiting Assistant</p>
        <p className="text-xs text-text-muted mt-1 mb-4">Find, filter, and prioritize the best candidates for each open role using plain English.</p>
        <div className="flex flex-wrap gap-2 mb-3">
          <select value={jobId} onChange={e => setJobId(e.target.value)} className="input-field text-xs w-52" data-testid="assistant-job-select">
            <option value="">All candidates</option>
            {jobs.map(j => <option key={j.id} value={j.id}>{j.title}</option>)}
          </select>
        </div>
        <div className="flex gap-2">
          <input value={message} onChange={e => setMessage(e.target.value)} onKeyDown={e => e.key === 'Enter' && ask()} placeholder="Ask about your candidate pool…" className="input-field flex-1" data-testid="assistant-input" />
          <button onClick={() => ask()} disabled={loading} className="btn-primary text-sm" data-testid="assistant-send-btn">{loading ? <i className="fa-solid fa-circle-notch fa-spin" /> : <i className="fa-solid fa-paper-plane" />}</button>
        </div>
        <div className="flex flex-wrap gap-2 mt-3">
          {QUICK.map((q, i) => <button key={i} onClick={() => { setMessage(q); ask(q); }} className="text-[11px] px-2.5 py-1 rounded-full bg-surface border border-border text-text-secondary hover:border-primary transition-all" data-testid={`quick-prompt-${i}`}>{q}</button>)}
        </div>
      </div>

      {loading && <div className="py-12 text-center text-text-muted text-sm"><i className="fa-solid fa-circle-notch fa-spin text-2xl block mb-3" />Thinking…</div>}

      {result && (
        <div className="space-y-4" data-testid="assistant-result">
          <div className="bg-surface rounded-2xl border border-border p-5">
            <p className="text-sm text-text-secondary">{result.reply}</p>
          </div>
          {result.ranked?.length > 0 && (
            <div className="bg-surface rounded-2xl border border-border p-5">
              <p className="text-xs font-bold uppercase text-text-muted mb-3">Prioritized shortlist</p>
              <div className="space-y-2">
                {result.ranked.map((c, i) => (
                  <div key={c.id || i} className="flex items-start gap-3 bg-surface-alt rounded-xl p-3" data-testid="ranked-candidate">
                    <span className="w-6 h-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{i + 1}</span>
                    <div><p className="text-sm font-semibold text-text-primary">{c.name}</p><p className="text-xs text-text-muted">{c.reason}</p></div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
